import HouseholdsBrowser from "./HouseholdsBrowser"
export default HouseholdsBrowser
